import { isSameDay } from '@/functions/date';

const ItemType = require('@/lib/Items/ItemType');
const { container } = require('@/container');

// @TODO rename
export const isGroupRedeemableCheck = (group, isLiveOrder) => {
    const redeemableGroups = [
        ItemType.TICKET,
        ItemType.MEMBERSHIP_PLAN,
    ];

    if (!group) {
        return false;
    }

    return isLiveOrder
        && !!(group && redeemableGroups.indexOf(group.itemType) !== -1
        && group.items.find((orderLine) => orderLine.isRedemptionAllowed()));
};

/**
 * Replaces OrderDetailCtrl.js $scope.redemptionEnabledForOrderLine();
 *
 * @param {OrderLine} orderLine
 *
 * @return {boolean}
 */
export const redemptionEnabledForOrderLineCheck = (orderLine) => {
    const isOnline = container.vuexService.getStore().state.isOnline;
    if (!isOnline && orderLine.ticketHasWaiver) {
        // Disable redemption if we're offline and there may be incomplete waivers.
        return false;
    }

    if (currentOrderHasIncompleteWaiversForItems([orderLine.itemID])) {
        // Disable redemption if we're online and there are incomplete waivers.
        return false;
    }

    return true;
};

/**
 * Replaces OrderDetailCtrl.js $scope.currentOrderHasIncompleteWaiversForItems
 *
 * Returns true if any of the waivers on this order apply to *any* of the given itemIDs.
 *
 * @param {number[]} itemIDs
 *
 * @return {boolean}
 */
export const currentOrderHasIncompleteWaiversForItems = (itemIDs) => {
    /**
     * @type {OrderWaiverStatus|null}
     */
    const currentOrderWaiverStatus = container.vuexService.getStore().state.orderDetails?.currentOrderWaiverStatus;

    if (
        currentOrderWaiverStatus
        && currentOrderWaiverStatus.hasIncompleteWaivers()
        && currentOrderWaiverStatus.containsWaiversForItems(itemIDs)
    ) {
        return true;
    }

    return false;
};

export const isCurrentGroupForSessionTodayCheck = (group) => {
    if (group && group.items[0].session) {
        return isSameDay(
            group.items[0].session.startTime,
            new Date()
        );
    }

    // Not a session-based group.
    return null;
};
